var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVolumeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-volumeOn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/volume_up_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3817 10.3454V6.31641C35.2246 8.09621 41.0725 15.0981 41.0725 23.4691C41.0725 31.84 35.2246 38.8419 27.3817 40.6217V36.5927C33.034 34.9107 37.1608 29.6691 37.1608 23.4691C37.1608 17.2691 33.034 12.0274 27.3817 10.3454ZM5.86749 17.6016V29.3366H13.6908L23.47 39.1157V7.8224L13.6908 17.6016H5.86749ZM32.2712 23.4691C32.2712 20.0072 30.2763 17.0344 27.3817 15.5871V31.3315C30.2763 29.9038 32.2712 26.9309 32.2712 23.4691Z",
    fill: "white",
    fillOpacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeOn);
export default __webpack_public_path__ + "static/media/icon-volumeOn.71399fa981881b24c11b7351a4db84cc.svg";
export { ForwardRef as ReactComponent };